<ami-dialog-message [setting]="message"></ami-dialog-message>

<ami-table-actions
  [settings]="table.settings"
  [data]="table.data"
  [actions]="table.actions"
  (action)="onReciveAction($event)"
></ami-table-actions>
<div *ngIf="openSideBar">
  <div *ngIf="itemToSideBar">
    <pg-products-provider-sidebar
      type="new"
      [item]="itemToSideBar"
      (close)="onCloseSideBar($event)"
    ></pg-products-provider-sidebar>
  </div>

  <div *ngIf="itemReceptionToSidebar">
    <pg-products-provider-sidebar
      type="new"
      [item]="itemReceptionToSidebar"
      [itemReception]="true"
      (close)="onCloseSideBar($event)"
    ></pg-products-provider-sidebar>
  </div>
  <div *ngIf="itemInvoiceToSidebar">
    <pg-products-provider-sidebar
      type="new"
      [item]="itemInvoiceToSidebar"
      [itemInvoice]="true"
      (close)="onCloseSideBar($event)"
    ></pg-products-provider-sidebar>
  </div>
</div>
